import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import Logo from '../../assets/home/logo_footer@2x.png'
import "./Footer.css";

class Footer extends Component {

    render() {
        return (
            <FooterComponent />
        );
    }
}

class FooterComponentBase extends Component {

    onClick = (page) => {
        switch(page){
            case "home" :
                return (this.props.history.push(ROUTES.HOME))
            case "search" :
                return (this.props.history.push(ROUTES.SEARCH))
            case "driving" :
                return (this.props.history.push(ROUTES.DRIVING))
            case "account" :
                return (this.props.history.push(ROUTES.ACCOUNT))
            default : 
                return
        }   
    }

    render() {
        return (
            <div className="footer-big-container">
                <div className="footer-small-container">
                    <div className="row footer-no-margin">
                        <div className="col">
                            <img src={Logo} className="footer-logo" alt="logo"/> 
                            <p className="footer-address">Association Loi 1901 </p>
                            <p className="footer-address">211 Chemin de la Madrague Ville,</p>
                            <p className="footer-address">13015 Marseille</p>
                        </div>

                        <div className="col">
                            <p className="footer-title">Menu</p>
                            <p className="footer-tabs cursor-pointer" onClick={() => this.onClick("home")}>Accueil</p> 
                            <p className="footer-tabs cursor-pointer" onClick={() => this.onClick("search")}>Rechercher</p> 
                            <p className="footer-tabs cursor-pointer" onClick={() => this.onClick("driving")}>Pilotage des capsules</p> 
                            <p className="footer-tabs cursor-pointer" onClick={() => this.onClick("account")}>Mon compte</p> 
                        </div>

                        <div className="col">
                            <p className="footer-title">Mentions Légales</p>
                            <p className="footer-tabs">Conditions Générales d’utilisation</p> 
                            <p className="footer-tabs">Conditions Générales de Vente</p> 
                            <p className="footer-tabs">Politique de confidentialité</p> 
                        </div>
                    </div>
                </div>
            </div>);
    };
}

const FooterComponent = withRouter(withFirebase(FooterComponentBase));

export default Footer;
export { FooterComponent };